export const getUserData = ({ id = "", result: [{ data = {} }], status = "" }) => {
  if (status !== "userSkills added") return null;

  return data;
};
